var React = require('react');

function XInline (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"3","y1":"23.4645","x2":"23.4645","y2":"3","stroke":"white","strokeWidth":"5","strokeLinecap":"round","key":0}),React.createElement("line",{"x1":"3.53553","y1":"3","x2":"24","y2":"23.4645","stroke":"white","strokeWidth":"5","strokeLinecap":"round","key":1})]);
}

XInline.defaultProps = {"width":"27","height":"27","viewBox":"0 0 27 27","fill":"none"};

module.exports = XInline;

XInline.default = XInline;
